<template>
    <div class="" :style="'border:1px solid;text-align:center; width:'+width+';'">
        <el-row>
            <el-col :span='11'><el-input :placeholder="'最小值'+info"  v-model="minval" clearable :disabled="disabled" @clear="handleMinClear" @change="handleMinChange" @keyup.native="handleMinkeyup"><template slot="append" v-if="unittext!=''">{{unittext}}</template></el-input></el-col>
            <el-col :span='1'>-</el-col>
            <el-col :span='12'><el-input :placeholder="'最大值'+info"  v-model="maxval" clearable :disabled="disabled" @clear="handleMaxClear" @change="handleMaxChange" @keyup.native="handleMaxkeyup"><template slot="append" v-if="unittext!=''">{{unittext}}</template></el-input></el-col>
        </el-row>
    </div>
</template>

<script>
export default {
  props:{
    value:{type:Array},
    width:{type:String, default:'80%'},
    unittext:{type:String, default:''},
    onlyInteger:{type:Boolean, default:false},
    disabled:{type:Boolean,default:false}
  },
  data(){
    return {
      minval:'',
      maxval:'',
      info:''
    };
  },

  watch:{
    value:function(newval){
      if(typeof(newval)==='object' && newval.length==2){
        this.minval=newval[0];
        this.maxval=newval[1];
      }
      else{
        this.minval=this.maxval='';
      }
    },       
  },
  mounted() {
    let newval=this.$props.value;
    if(typeof(newval)==='object' && newval.length==2){
      this.minval=newval[0];
      this.maxval=newval[1];
    }
    else{
      this.minval=this.maxval='';
    }
    this.info =  this.$props.onlyInteger?'(整数)':'';
  },
  methods:{
    handleMinkeyup(){
      if(this.onlyInteger){
        this.minval=this.minval.replace(/[^\.\d]/g,'');
        this.minval=this.minval.replace('.','');
      }
    },
    handleMaxkeyup(){
      if(this.onlyInteger){
        this.maxval=this.maxval.replace(/[^\.\d]/g,'');
        this.maxval=this.maxval.replace('.','');
      }
    },
    handleMinChange(val){
      if(isNaN(this.maxval) || parseInt(this.maxval)<parseInt(val))this.maxval=val;
      let vals=[];
      if(!isNaN(this.minval) && !isNaN(this.maxval))
      {
        vals.push(this.minval);
        vals.push(this.maxval);
      }
      this.$emit('input', vals);
    },
    handleMaxChange(val){            
      if(parseInt(this.minval)>parseInt(val))this.minval=val;
      let vals=[];
      if(!isNaN(this.minval) && !isNaN(this.maxval))
      {
        vals.push(this.minval);
        vals.push(this.maxval);
      }
      this.$emit('input', vals);
    },
    handleMinClear(){
      this.$emit('input',[]);
    },
    handleMaxClear(){
      this.$emit('input',[]);
    }
  }
};
</script>
